'use client';

import { Link } from '@/i18n/routing';
import { button, textStyles } from '@mage-ui/styled-system/recipes';
import { Section } from '../../layouts/sections/Section';

import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { useContext } from 'react';

export const MailValidation = ({ status, language }) => {
  const { st } = useContext(StaticTextContext);

  const responseStatus = status === 201 ? 'ok' : 'ko';

  return (
    <Section
      heading={{
        title: st(`email_validation.${responseStatus}.title`),
      }}
    >
      <div
        className={textStyles()}
        dangerouslySetInnerHTML={{
          __html: st(`email_validation.${responseStatus}.content`) || '',
        }}
      />
      <div>
        <Link href={`/${language || ''}`} className={button()}>
          {st('email_validation.back_to_home')}
        </Link>
      </div>
    </Section>
  );
};
